{
  "sdk-download-android": "Baixar para Android",
  "sdk-connect": "Conecte",
  "sdk-download-ios": "Baixar para iOS",
  "sdk-install": "Instalar",
  "sdk-modal-instruct-1": "1. Abra o Aplicativo da Binance",
  "sdk-modal-instruct-2": "2. Toque em {{icon}} na Tela Inicial",
  "sdk-modal-title": "Conectar com a Binance",
  "sdk-no-app": "Ainda não tem o aplicativo da Binance?"
}